<template>
  <div>
    <div id="store" v-if="isPC">
      <div class="main">
        <p class="page-title">{{ $t('store.stores') }}</p>
        <div class="store bg-white">
          <div class="page-head">
            <div class="f--c">
              <span>{{ $t('store.allowStoreBinding') }}：</span>
              <div class="f--c">
                <div class="head-platForm-img pointer f-c-c" @click="filterStore('SP')" :class="{'actived':platformCodeNow==='SP'}">
                  <i class="iconfont icon-checkbox-circle-fill" v-show="platformCodeNow==='SP'"></i>
                  <img style="max-width:100%" src="@/assets/img/homePage/shopify.png" alt="" />
                </div>
                <div class="head-platForm-img pointer f-c-c" @click="filterStore('DJ')" :class="{'actived':platformCodeNow==='DJ'}">
                  <i class="iconfont icon-checkbox-circle-fill" v-show="platformCodeNow==='DJ'"></i>
                  <img style="max-width:100%" src="@/assets/img/homePage/shoplazza.png" alt="" />
                </div>
                <div class="head-platForm-img pointer f-c-c" @click="filterStore('SL')" :class="{'actived':platformCodeNow==='SL'}">
                  <i class="iconfont icon-checkbox-circle-fill" v-show="platformCodeNow==='SL'"></i>
                  <img style="max-width:100%" src="@/assets/img/homePage/shopline.png" alt="" />
                </div>
                <div class="head-platForm-img pointer f-c-c" @click="filterStore('WC')" :class="{'actived':platformCodeNow==='WC'}">
                  <i class="iconfont icon-checkbox-circle-fill" v-show="platformCodeNow==='SL'"></i>
                  <img style="max-width:100%" src="@/assets/img/homePage/woocommerce.png" alt="" />
                </div>
              </div>
            </div>
            <p>{{ $t('store.storeTips') }}</p>
          </div>
          <p style="color:#99c41c;padding-bottom:15px" class="pointer" @click="toToturial">{{$t('store.addStoreVideoTip')}} <i class="iconfont icon-play-circle-line"></i> </p>
          <div class="store-list">
            <div class="add-store-box">
              <div class="add-store f-c-c" @click="showPlatformSelect">
                <div class="f-c-c fd-c">
                  <i class="iconfont icon-a-add-line1" style="font-size:30px"></i>
                  <p>{{ $t('store.connectANewStore') }}</p>
                </div>
              </div>
              <div style="height:30px"></div>
            </div>

            <div class="store-box" v-for="item in storeList" :key="item.id">
              <div class="store-card">
                <div class="store-type f-b-c">
                  <div class="plat-img">
                    <img v-if="item.platformCode==='SP'" style="width:100%" src="@/assets/img/homePage/shopify.png" alt="" />
                    <img v-if="item.platformCode==='DJ'" style="width:100%" src="@/assets/img/homePage/shoplazza.png" alt="" />
                    <img v-if="item.platformCode==='SL'" style="width:100%" src="@/assets/img/homePage/shopline.png" alt="" />
                    <img v-if="item.platformCode==='WC'" style="width:100%" src="@/assets/img/homePage/woocommerce.png" alt="" />
                    <img v-if="item.platformCode==='TT'" style="width:100%" src="@/assets/img/homePage/tiktok.png" alt="" />
                  </div>
                  <el-switch @change="value => modefyStoreStatus(value, item.storeId)" :value="item.storeStatus" :active-value="1" :inactive-value="0"></el-switch>
                </div>
                <div class="store-info f-b-c">
                  <div class="store-title">
                    <i class="iconfont icon-store-line"></i>
                    <span>{{ item.storeName }}</span>
                    <p v-if="item.authorizeStatus === 0">{{ $t('store.unauthorized') }}</p>
                    <p v-else>{{ $t('store.authorized') }}</p>
                  </div>
                  <div class="store-setting pointer">
                    <i class="el-icon-setting" style="font-size:18px;"></i>
                    <span @click="handleStoreSetting(item.storeId)">{{$t('store.storeSettings')}}</span>
                  </div>
                </div>
              </div>
              <div style="height:30px">
                <span class="pointer" v-if="item.authorizeStatus === 0" @click="handleReauthorize(item.storeId, item)">{{ $t('store.reauthorize') }}</span>
                <span class="delete pointer" @click="deleteStore(item.storeId)">{{$t('common.delete')}}</span>
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <!-- 选择平台 -->
      <el-dialog :title="$t('store.connectANewStore')" :visible.sync="platformDialogVisible" width="690px" :before-close="handleClose" :close-on-click-modal="false">
        <div class="f--c" style="margin-bottom:20px">{{ $t('store.chooseStoreTip') }}</div>
        <div class="f fw-w">
          <div class="platForm-img pointer f-c-c" @click="choosePlatForm('SP', 545)" :class="{'actived':platformCode==='SP'}">
            <i class="iconfont icon-checkbox-circle-fill" v-show="platformCode==='SP'"></i>
            <img style="width:70%" src="@/assets/img/homePage/shopify.png" alt="" />
          </div>
          <div class="platForm-img pointer f-c-c" @click="choosePlatForm('DJ', 546)" :class="{'actived':platformCode==='DJ'}">
            <i class="iconfont icon-checkbox-circle-fill" v-show="platformCode==='DJ'"></i>
            <img style="width:70%" src="@/assets/img/homePage/shoplazza.png" alt="" />
          </div>
          <div class="platForm-img pointer f-c-c" @click="choosePlatForm('SL', 547)" :class="{'actived':platformCode==='SL'}">
            <i class="iconfont icon-checkbox-circle-fill" v-show="platformCode==='SL'"></i>
            <img style="width:70%" src="@/assets/img/homePage/shopline.png" alt="" />
          </div>
          <div class="platForm-img pointer f-c-c" @click="choosePlatForm('WC')" :class="{'actived':platformCode==='WC'}">
            <i class="iconfont icon-checkbox-circle-fill" v-show="platformCode==='WC'"></i>
            <img style="width:68%" src="@/assets/img/homePage/woocommerce.png" alt="" />
          </div>
          <div class="platForm-img pointer f-c-c" @click="choosePlatForm('TT')" :class="{'actived':platformCode==='TT'}">
            <i class="iconfont icon-checkbox-circle-fill" v-show="platformCode==='TT'"></i>
            <img style="width:70%" src="@/assets/img/homePage/tiktok.png" alt="" />
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handlePlatformCancel">{{  $t('common.cancel') }}</el-button>
          <el-button type="primary" @click="toNext">{{ $t('common.next')}}</el-button>
        </span>
      </el-dialog>

      <!-- 新增店铺 -->
      <el-dialog :title="$t('store.connectANewStore')" :visible.sync="dialogVisible" width="700px" :before-close="handleClose" :close-on-click-modal="false">
        <el-form :model="newStoreForm" label-position="left" :rules="rules" ref="storeForm" @submit.native.prevent>
          <el-form-item :label="$t('PersonalCenter.Store.Index.DefaultDomain')" prop="storeName">
            <el-input :placeholder="$t('common.pleaseEnter')" v-model="newStoreForm.storeName" style="width:450px" @keyup.enter.native="connectNewStore">
            </el-input>
          </el-form-item>
        </el-form>
        <div class="tips-box">
          <p v-if="platformCode==='SP'">1.{{$t('store.shopifyTips')}}</p>
          <p v-if="platformCode==='SP'" style="text-indent:14px"> {{$t('store.eg')}} <span>{{$t('store.shopifyTips1')}}</span> </p>
          <p v-if="platformCode==='DJ'">1.{{$t('store.shoplazzaTips')}}</p>
          <p v-if="platformCode==='DJ'" style="text-indent:14px"> {{$t('store.eg')}} <span>{{$t('store.shoplazzaTips1')}}</span> </p>
          <p v-if="platformCode==='SL'">1.{{$t('store.shoplineTips')}}</p>
          <p v-if="platformCode==='SL'" style="text-indent:14px"> {{$t('store.eg')}} <span>{{$t('store.shoplineTips1')}}</span> </p>
          <p>2.{{$t('store.addStoreTip')}} <span>{{$t('store.addStoreTip2')}}</span></p>
          <p style="color:#99c41c" class="pointer" @click="toToturial">{{$t('store.addStoreVideoTip')}} <i class="iconfont icon-play-circle-line"></i> </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleCancel">{{  $t('common.cancel') }}</el-button>
          <el-button type="primary" @click="connectNewStore">{{ $t('common.confirm')}}</el-button>
        </span>
      </el-dialog>
      <!-- 修改店铺状态 -->
      <el-dialog :visible.sync="changeStatusVisible" width="500px" :before-close="handleCloseStoreClose">
        <div class="f">
          <div style="margin-right: 4px">
            <i class="el-icon-question" style="color: #99C41C;"></i>
          </div>
          <div>
            <div class="tips-title" style="color: #99C41C;font-size:16px;margin-bottom: 20px"> {{ $t('store.closeStoreAlert') }}</div>
            <div class="tips-title">{{ $t('store.closeStoreTips') }}</div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="changeStatusVisible = false">{{ $t('common.cancel')}}</el-button>
          <el-button type="primary" :loading="closeLoading" @click="checkCloseStore">{{ $t('common.confirm') }}</el-button>
        </span>
      </el-dialog>

      <!-- 删除店铺 -->
      <el-dialog :visible.sync="deleteStoreVisible" width="500px" :before-close="handleDeleteStoreClose">
        <div class="f">
          <div style="margin-right: 4px">
            <i class="el-icon-question" style="color: #99C41C;"></i>
          </div>
          <div>
            <div style="color: #99C41C;" class="tips-title"> {{$t('store.removeStoreTitle')}}</div>
            <div class="tips-title">{{ $t('store.removeStoreTips1') }}</div>
            <ul style="padding-left:28px">
              <li>{{ $t('store.listings') }}</li>
              <li>{{ $t('store.OrdersOfstore') }}</li>
            </ul>
            <div class="tips-title">{{ $t('store.removeStoreTips') }}</div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteStoreVisible = false">{{$t('common.cancel')}}</el-button>
          <el-button type="primary" @click="handleDeleteStore" :loading="deleteLoading">{{ $t('store.removeTheStore') }}</el-button>
        </span>
      </el-dialog>
      <!-- woocommerce店铺授权 -->
      <el-dialog :title="$t('store.connectANewStore')" :visible.sync="woocommerceVisible" width="700px" :before-close="handleClose" :close-on-click-modal="false">
        <el-form :model="woocommerceForm" label-position="right" :rules="rules" ref="woocommerceForm" @submit.native.prevent label-width="140px">
          <el-form-item :label="$t('PersonalCenter.Store.Index.StoreURL')" prop="storeUrl">
            <el-input :placeholder="$t('common.pleaseEnter')" v-model="woocommerceForm.storeUrl" :disabled="(!!woocommerceForm.flag && !!woocommerceForm.storeUrl) || !!$route.query.url" style="width:450px" @blur="handleStoreUrlBlur">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('PersonalCenter.Store.Index.StoreName')" prop="storeName">
            <el-input :placeholder="$t('common.pleaseEnter')" v-model.trim="woocommerceForm.storeName" :disabled="!!woocommerceForm.flag && !!woocommerceForm.storeName" style="width:450px">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('PersonalCenter.Store.Index.ConsumerKey')" prop="consumerKey">
            <el-input :placeholder="$t('common.pleaseEnter')" v-model="woocommerceForm.consumerKey" style="width:450px">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('PersonalCenter.Store.Index.ConsumerSecret')" prop="consumerSecret">
            <el-input :placeholder="$t('common.pleaseEnter')" v-model="woocommerceForm.consumerSecret" style="width:450px">
            </el-input>
          </el-form-item>
        </el-form>
        <div class="woocommerce-tips">
          <h1>{{ $t('PersonalCenter.Store.Index.WhereToFind') }}:</h1>
          <p>{{ $t('PersonalCenter.Store.Index.Tips1') }}</p>
          <p>{{ $t('PersonalCenter.Store.Index.Tips2') }}</p>
          <p>{{ $t('PersonalCenter.Store.Index.Tips3') }}</p>
          <ul>
            <li><b>{{ $t('PersonalCenter.Store.Index.Description') }}:</b> {{ $t('PersonalCenter.Store.Index.Tips4') }}</li>
            <li><b>{{ $t('PersonalCenter.Store.Index.User') }}:</b> {{ $t('PersonalCenter.Store.Index.Tips5') }}</li>
            <li><b>{{ $t('PersonalCenter.Store.Index.Permissions') }}:</b> {{ $t('PersonalCenter.Store.Index.SelectReadWrite') }}</li>
            <li>{{ $t('PersonalCenter.Store.Index.SelectGenerateAPIKey') }}</li>
          </ul>
          <!-- <a @click="jump">Still confused？Check video description.</a> -->
          <router-link
            :to="{ path: '/tutorial-content', query: { category_id: '1442847', name: 'Sync with KakaClo', _index: 1 } }"
              target="_blank"
            >
            {{ $t('PersonalCenter.Store.Index.Tips6') }}
          </router-link>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleCancel">{{  $t('common.cancel') }}</el-button>
          <el-button type="primary" @click="bindWoocommerceStore">{{ $t('common.confirm')}}</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="mobile-store bg-white" v-else>
      <Tips>{{ $t('PersonalCenter.Store.Index.Tips7') }}</Tips>
      <div class="mobile-store-container">
        <span>{{ $t('store.allowStoreBinding') }}：</span>
        <div class="f--c">
          <div class="mobile-head-platForm-img pointer f-c-c" @click="filterStore('SP')" :class="{'actived':platformCodeNow==='SP'}">
            <img style="max-width:100%" src="@/assets/img/homePage/shopify.png" alt="" />
          </div>
          <div class="mobile-head-platForm-img pointer f-c-c" @click="filterStore('DJ')" :class="{'actived':platformCodeNow==='DJ'}">
            <img style="max-width:100%" src="@/assets/img/homePage/shoplazza.png" alt="" />
          </div>
          <div class="mobile-head-platForm-img pointer f-c-c" @click="filterStore('SL')" :class="{'actived':platformCodeNow==='SL'}">
            <img style="max-width:100%" src="@/assets/img/homePage/shopline.png" alt="" />
          </div>
          <div class="mobile-head-platForm-img pointer f-c-c" @click="filterStore('WC')" :class="{'actived':platformCodeNow==='WC'}">
            <img style="max-width:100%" src="@/assets/img/homePage/woocommerce.png" alt="" />
          </div>
          <div class="mobile-head-platForm-img pointer f-c-c" @click="filterStore('TT')" :class="{'actived':platformCodeNow==='TT'}">
            <img style="max-width:100%" src="@/assets/img/homePage/tiktok.png" alt="" />
          </div>
        </div>
        <div class="mobile-store-box" v-for="item in storeList" :key="item.id">
          <div class="mobile-store-card">
            <!-- <div class="store-type f-b-c"> -->
            <div class="mobile-plat-img">
              <img v-if="item.platformCode==='SP'" src="@/assets/img/homePage/shopify.png" alt="" />
              <img v-if="item.platformCode==='DJ'" src="@/assets/img/homePage/shoplazza.png" alt="" />
              <img v-if="item.platformCode==='SL'" src="@/assets/img/homePage/shopline.png" alt="" />
              <img v-if="item.platformCode==='WC'" src="@/assets/img/homePage/woocommerce.png" alt="" />
              <img v-if="item.platformCode==='TT'" src="@/assets/img/homePage/tiktok.png" alt="" />
            </div>
            <!-- <el-switch @change="value => modefyStoreStatus(value, item.storeId)" :value="item.storeStatus" :active-value="1" :inactive-value="0"></el-switch> -->
            <!-- </div> -->
            <div class="mobile-store-info f-b-c">
              <div class="store-title">
                <i class="iconfont icon-store-line"></i>
                <span>{{ item.storeName }}</span>
                <p v-if="item.authorizeStatus === 0">{{ $t('store.unauthorized') }}</p>
                <p v-else>{{ $t('store.authorized') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 设置账号 -->
    <AccountSetting ref="accountSetting" @setSuccess="setSuccess"></AccountSetting>
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import Tips from '@/components/mobile/Tips.vue'
import { checkStoreLink } from '@/util/validate'
import { setStorage, getStorage } from '@/util/index'
import AccountSetting from '@/views/personal-center/account-setting/components/AccountSetting.vue'
let validStoreLink = (rule, value, callback) => {
  if (checkStoreLink(value)) {
    callback()
  } else {
    callback(
      new Error(`You counld enter English letters,numbers,'-'and'_',Start and end with numbers or letters.`) // new Error(`${this.$t('PersonalCenter.Store.Index.Tips8')}`)
    )
  }
}
export default {
  components: { Tips, AccountSetting },
  data() {
    return {
      changeStatusVisible: false,
      deleteStoreVisible: false,
      au: true,
      un: false,
      input1: '',
      dialogVisible: false,
      platformDialogVisible: false, // 选择平台弹窗
      deleteLoading: false,
      woocommerceVisible: false,
      closeLoading: false,
      newStoreForm: {
        platformCode: ''
      },
      woocommerceForm: {
        consumerKey: undefined,
        consumerSecret: undefined,
        storeUrl: undefined,
        flag: 0
      },
      platformCode: '',
      platformCodeNow: '',
      addForm: {},
      options: [],
      value: '',
      rules: {
        storeName: [{ required: true, message: `${this.$t('PersonalCenter.Store.Index.Tips9')}`, trigger: 'blur' }, { validator: validStoreLink, trigger: 'blur' }, { max: 100, trigger: 'blur' }],
        storeUrl: [{ required: true, message: `${this.$t('PersonalCenter.Store.Index.Tips10')}`, trigger: 'blur' }],
        consumerKey: [{ required: true, message: `${this.$t('PersonalCenter.Store.Index.Tips11')}`, trigger: 'blur' }],
        consumerSecret: [{ required: true, message: `${this.$t('PersonalCenter.Store.Index.Tips12')}`, trigger: 'blur' }]
      },
      storeList: [],
      storeListCopy: [],
      storeStatus: 0,
      deleteId: '',
      modifyStoreForm: {}
    }
  },
  created() {
    const storeId = this.$route.query.storeId
    if (storeId || getStorage('storeId')) {
      !this.$store.state.common.userId && setStorage('storeId', storeId, 2 * 60 * 60 * 1000)
      this.userBindStore(storeId)
      return
    }
    this.getStoreList()
  },
  mounted() {
    if (this.$route.query.from) this.woocommerceVisible = true
    if (this.$route.query.url) {
      let url = this.$route.query.url.split('/')
      this.$set(this.woocommerceForm, 'storeUrl', `${url[0]}//${url[2]}`)
    }
  },
  methods: {
    filterStore(code) {
      // this.platformCodeNow = code
      this.storeList = _.cloneDeep(this.storeListCopy)
      // let storeList = _.cloneDeep(this.storeList)
      // this.storeList = storeList.filter(item => item.platformCode === code)
    },

    toToturial() {
      window.open('https://www.kakaclo.com/tutorial-content?category_id=1442847&name=Sync%20with%20KakaClo')
    },
    // 从亚马逊跳转到kaka后，将用户和店铺绑定
    userBindStore(storeId) {
      API.userBindStore({ storeId }).then((res) => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.getStoreList()
        if (getStorage('storeId')) {
          localStorage.removeItem('storeId')
        }
      }).catch(result => {
        this.$message.error(result.data.message)
      })
    },
    getStoreList() {
      API.getStoreList()
        .then(res => {
          this.storeList = res.data
          this.storeListCopy = res.data
        })
        .catch(result => {
          this.$message.error(result.data.message)
        })
    },
    modefyStoreStatus(value, id) {
      this.storeStatus = value
      this.modifyStoreForm = new FormData()
      this.modifyStoreForm.append('storeId', id)
      this.modifyStoreForm.append('storeStatus', value)
      if (value === 1) {
        this.handleModefyStoreStatus()
      } else {
        this.changeStatusVisible = true
      }
    },
    checkCloseStore() {
      this.handleModefyStoreStatus()
    },
    handleModefyStoreStatus() {
      API.modefyStoreStatus(this.modifyStoreForm)
        .then(res => {
          if (this.storeStatus === 1) {
            this.$message.success(this.$t('store.openStoreMsg'))
          } else {
            this.changeStatusVisible = false
            this.$message.success(this.$t('store.closeStoreMsg'))
          }
          this.getStoreList()
        })
        .catch(res => {
          this.$message.error(res.data.message)
        })
    },
    handleStoreSetting(storeId) {
      this.$router.push({
        path: '/personal-center/store-setting',
        query: { storeId: storeId }
      })
    },
    handleReauthorize(storeId, row) {
      if (row.platformCode === 'WC') {
        this.woocommerceForm.storeUrl = row.storeUrl
        this.woocommerceForm.storeName = row.storeName
        this.woocommerceForm.flag = 1
        this.woocommerceVisible = true
        return
      }
      API.handleReauthorize(storeId)
        .then(res => {
          window.open(res.data)
        })
        .catch(result => {
          this.$message.error(result.data.message)
        })
    },

    // 选择店铺平台
    choosePlatForm(value, event_id) {
      this.newStoreForm.platformCode = value
      this.platformCode = value
    },

    chooseWooCommerce(value) {
      this.platformCode = value
      this.woocommerceVisible = true
    },

    handlePlatformCancel() {
      this.newStoreForm.platformCode = ''
      this.platformCode = ''
      this.platformDialogVisible = false
    },

    // 选择店铺下一步
    toNext() {
      if (this.platformCode === '') { return this.$message.error(this.$t('promptText.msg42')) }
      this.platformDialogVisible = false
      if (this.platformCode === 'SP') return window.open('https://apps.shopify.com/order-6')
      if (this.platformCode === 'WC') {
        this.woocommerceForm.flag = 0
        this.woocommerceVisible = true
        return false
      }
      if (this.platformCode === 'TT') return this.$message.warning(this.$t('PersonalCenter.Store.Index.Tips13')) // window.open('https://services.us.tiktokshop.com/open/authorize?service_id=7257018034890868523')
      this.dialogVisible = true
    },

    // 返回上一步
    handleCancel() {
      this.dialogVisible = false
      this.woocommerceVisible = false
      this.platformDialogVisible = true
      this.$refs.storeForm.clearValidate()
      this.$refs.woocommerceForm.clearValidate()
      this.woocommerceForm = {
        consumerKey: undefined,
        consumerSecret: undefined,
        storeUrl: undefined
      }
    },

    // 确定新增店铺
    connectNewStore() {
      this.$refs.storeForm.validate(valid => {
        if (!valid) return
        let platformCom = ''
        switch (this.platformCode) {
          case 'SP':
            platformCom = 'myshopify.com'
            break
          case 'DJ':
            platformCom = 'myshoplaza.com'
            break
          case 'SL':
            platformCom = 'myshopline.com'
            break
          default:
            break
        }
        this.newStoreForm.storeUrl = `https://${this.newStoreForm.storeName}.${platformCom}`
        API.connectNewStore(this.newStoreForm)
          .then(res => {
            if (res.code !== 10000) {
              return this.$message.error(res.message)
            }
            this.$message.success(this.$t('common.success'))
            this.dialogVisible = false
            this.platformCode = ''
            this.newStoreForm = { platformCode: '' }
            window.open(res.data)
            this.getStoreList()
          }).catch(err => { this.$message.error(err.message || err.data.message) })
      })
    },
    handleClose() {
      this.platformDialogVisible = false
      this.dialogVisible = false
      this.newStoreForm = { platformCode: '' }
      this.platformCode = ''
      this.woocommerceVisible = false
      this.woocommerceForm = {
        consumerKey: undefined,
        consumerSecret: undefined,
        storeUrl: undefined
      }
    },
    handleCloseStoreClose() {
      this.changeStatusVisible = false
    },
    handleDeleteStoreClose() {
      this.deleteStoreVisible = false
    },
    handleDeleteStore() {
      this.deleteLoading = true
      API.deleteStore(this.deleteId)
        .then(res => {
          this.$message.success(this.$t('common.success'))
          this.deleteStoreVisible = false
          this.deleteLoading = false
          this.getStoreList()
        })
        .catch(result => {
          this.$message.error(result.data.message)
        })
        .finally(() => {
          this.deleteLoading = false
        })
    },
    deleteStore(id) {
      this.deleteStoreVisible = true
      this.deleteId = id
    },
    bindWoocommerceStore() {
      this.$refs.woocommerceForm.validate(valid => {
        if (!valid) return
        let form = {
          tokenVO: {
            consumerKey: this.woocommerceForm.consumerKey,
            consumerSecret: this.woocommerceForm.consumerSecret
          },
          storeUrl: this.woocommerceForm.storeUrl,
          storeName: this.woocommerceForm.storeName,
          flag: this.woocommerceForm.flag || 0
        }
        API.bindWoocommerceStore(form).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          this.$message.success(this.$t('common.success'))
          if (this.$route.query.url) {
            let url = this.$route.query.url
            // if (url.includes('?')) url = `${url}&userId=${this.$store.state.common.userId}&email=${this.$store.state.common.email}`
            // else url = `${url}?userId=${this.$store.state.common.userId}&email=${this.$store.state.common.email}`
            url = `${url}?page=wc-settings&tab=settings_kaka&userId=${this.$store.state.common.userId}&email=${this.$store.state.common.email}`
            window.open(url)
          }
          this.handleClose()
          this.getStoreList()
        })
          .catch(result => {
            this.$message.error(result.data.message)
          })
      })
    },
    handleStoreUrlBlur() {
      let url = this.woocommerceForm.storeUrl
      let storeName = this.woocommerceForm.storeName || ''
      if (!storeName) return
      let urlArr = ['https://www.', 'https://', 'http://www.', 'http://']
      urlArr.forEach(item => {
        if (url.includes(item)) {
          url = url.split(item)[1]
          storeName = url.split('.')[0]
          this.$set(this.woocommerceForm, 'storeName', storeName)
        }
      })
    },
    showPlatformSelect() {
      if (!this.$store.state.common.email) {
        this.$refs.accountSetting.show('bindEmail')
      } else {
        this.platformDialogVisible = true
      }
    },
    setSuccess() {
      // 弹出平台选择框
      this.platformDialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
#store {
  font-family: Arial;
  margin: 18px 0 0 0;
}
.tips-title {
  font-size: 14px;
  line-height: 26px;
}
.store {
  padding: 22px 38px;
}
.page-title {
  display: inline-block;
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  padding-bottom: 10px;
}
.clear {
  margin: 0px auto;
  clear: both;
  height: 0px;
  font-size: 0px;
  overflow: hidden;
}
/deep/.el-button--success {
  border-color: none;
  border: none;
  background: #99c41c;
}
/deep/.el-form-item__label {
  font-size: 14px;
  line-height: 36px;
}
/deep/.el-input__inner {
  height: 36px;
}
/deep/.el-input-group__prepend {
  border-radius: 18px 0 0 18px;
}
/deep/.el-input-group__append {
  border-radius: 0 18px 18px 0;
}
.store-list {
  padding-bottom: 40px;
}
.page-head {
  span {
    display: inline-block;
    font-size: 14px;
    color: #000000;
  }
  p {
    font-size: 14px;
    line-height: 20px;
    padding: 15px 0 10px;
  }
}
.add-store-box {
  max-width: 420px;
  width: 45%;
  min-width: 360px;
  float: left;
  margin-right: 20px;
  margin-bottom: 10px;
}
.add-store {
  width: 100%;
  height: 173px;
  border: 1px dashed #cdd4dd;
  box-sizing: border-box;
  border-radius: 6px;
  p {
    font-size: 14px;
    line-height: 20px;
    margin-top: 15px;
  }
}
.store-box {
  float: left;
  margin-right: 20px;
  margin-bottom: 10px;
  min-width: 360px;
  max-width: 420px;
  width: 45%;
  span {
    font-size: 14px;
    line-height: 20px;
  }
}
.store-card {
  width: 100%;
  height: 172.4px;
  border: 0.5px solid #cdd4dd;
  box-sizing: border-box;
  border-radius: 6px;
  margin-bottom: 10px;
  padding: 12px 25px;
}
.delete {
  display: inline-block;
  color: #8b93a3;
  margin-left: 20px;
}
.store-info {
  margin-top: 30px;
  margin-bottom: 10px;
}
.store-setting {
  font-size: 14px;
  line-height: 20px;
  color: #99c41c;
  span {
    display: inline-block;
    margin-left: 3px;
    color: #99c41c;
  }
}
.tips-box {
  p {
    font-size: 14px;
    line-height: 21px;
    color: #8b93a3;
    span {
      color: #303133;
    }
  }
}
.store-title {
  font-size: 14px;
  line-height: 20px;
  p {
    padding-top: 10px;
    color: #8b93a3;
  }
}
.icon {
  display: inline-block;
  margin: 15px;
  text-align: center;
  font-size: 18px;
  line-height: 27px;
  // width: 100%;
}
/deep/.el-message-box__wrapper .el-message-box {
  width: 500px !important;
  display: inline-block;
}
.message-content {
  max-width: 370px;
  margin: 0 33px;
  font-size: 14px;
  line-height: 21px;
  color: #747a87;
}
.head-platForm-img {
  width: 140px;
  height: 50px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.platForm-img {
  position: relative;
  width: 200px;
  height: 60px;
  border: 1px solid #cdd4dd;
  box-sizing: border-box;
  border-radius: 6px;
  margin: 0 8px 16px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.actived {
  border: 2px solid #99c41c !important;
  box-shadow: 0px 4px 4px rgba(139, 147, 163, 0.13);
}
.plat-img {
  width: 120px;
  height: 40px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.icon-checkbox-circle-fill {
  position: absolute;
  right: 3px;
  top: 3px;
  font-size: 20px;
  color: #99c41c;
}
/deep/.el-dialog__body {
  padding: 10px 20px 20px;
}

// 移动端样式
.mobile-store {
  width: 100vw;
  min-height: calc(100vh - 0.86rem);
}
.mobile-store-container {
  border-top: 0.5px solid #cdd4dd;
  padding: 0.3rem 0.32rem;
}
.mobile-head-platForm-img {
  width: 2rem;
  height: 0.8rem;
  margin-right: 3px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.mobile-store-box {
  width: 100%;
  padding-top: 0.2rem;
}
.mobile-store-card {
  width: 100%;
  border: 0.5px solid #cdd4dd;
  box-sizing: border-box;
  border-radius: 6px;
  margin-bottom: 0.2rem;
  padding: 0.2rem 0.3rem;
}
.mobile-plat-img {
  width: 2.5rem;
  margin-bottom: 0.3rem;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.woocommerce-tips {
  margin-top: 30px;
  h1 {
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    color: #10141D;
    margin-bottom: 10px;
  }
  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    color: #747a87;
  }
  ul li {
    list-style: none;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    color: #747a87;
    text-indent: 32px;
  }
  a {
    display: block;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    color: #99c41c;
    margin-top: 15px;
  }
}
</style>
